export default {
	field: 'transactionItem.transactionId',
	name: 'Transaction ID',
	width: '102px',
}
